const C = {
  primary: '#6366f1', success: '#10b981', warning: '#f59e0b',
  danger: '#ef4444', secondary: '#06b6d4', accent: '#ec4899',
  textDim: 'rgba(255,255,255,0.4)',
};

// ─── Supply Chain ───
export const SUPPLY_CHAIN_DATA = {
  'create-po': {
    type: 'form',
    title: 'Create Purchase Order',
    fields: [
      { key: 'vendor', label: 'Vendor', placeholder: 'Select vendor...', type: 'text' },
      { key: 'items', label: 'Items Description', placeholder: 'Describe items needed...', type: 'textarea' },
      { key: 'quantity', label: 'Quantity', placeholder: '0', type: 'number' },
      { key: 'amount', label: 'Total Amount (SAR)', placeholder: '0.00', type: 'number', prefix: 'SAR' },
      { key: 'delivery_date', label: 'Expected Delivery', placeholder: 'YYYY-MM-DD', type: 'text' },
      { key: 'priority', label: 'Priority', placeholder: 'Low / Medium / High', type: 'text' },
      { key: 'notes', label: 'Notes', placeholder: 'Additional notes...', type: 'textarea' },
    ],
  },
  'approve-po': {
    type: 'list',
    title: 'Pending Approvals',
    actions: ['approve', 'reject'],
    items: [
      {
        id: 'PR-2024-001', title: 'IT Equipment for New Office', subtitle: 'Requester: Ahmed Hassan · IT Dept',
        detail: 'SAR 45,000', status: 'pending', statusColor: C.warning, icon: 'document-text',
        priority: 'high', date: '2024-03-15',
        lineItems: [
          { name: 'Dell XPS 15 Laptops', qty: 15, price: 'SAR 2,500', total: 'SAR 37,500' },
          { name: 'Dell 27" Monitors', qty: 15, price: 'SAR 500', total: 'SAR 7,500' },
        ],
        workflow: [
          { step: 'Submitted', user: 'Ahmed Hassan', date: 'Mar 15, 09:30', status: 'completed' },
          { step: 'Department Review', user: 'Sarah Al-Rashid', date: 'Mar 15, 14:20', status: 'completed' },
          { step: 'Budget Approval', user: 'Finance Team', date: 'Mar 16, 11:15', status: 'completed' },
          { step: 'Procurement Review', user: 'Procurement', date: '', status: 'current' },
          { step: 'Vendor Selection', user: '', date: '', status: 'pending' },
          { step: 'PO Creation', user: '', date: '', status: 'pending' },
        ],
      },
      {
        id: 'PR-2024-002', title: 'Kitchen Equipment Replacement', subtitle: 'Requester: Fatima K. · Operations',
        detail: 'SAR 18,500', status: 'urgent', statusColor: C.danger, icon: 'document-text',
        priority: 'critical', date: '2024-03-14',
        lineItems: [
          { name: 'Commercial Oven', qty: 1, price: 'SAR 12,000', total: 'SAR 12,000' },
          { name: 'Prep Table (Steel)', qty: 2, price: 'SAR 3,250', total: 'SAR 6,500' },
        ],
        workflow: [
          { step: 'Submitted', user: 'Fatima K.', date: 'Mar 14, 08:00', status: 'completed' },
          { step: 'Department Review', user: 'Ops Manager', date: 'Mar 14, 10:30', status: 'completed' },
          { step: 'Budget Approval', user: 'Finance', date: '', status: 'current' },
          { step: 'Procurement Review', user: '', date: '', status: 'pending' },
        ],
      },
      {
        id: 'PR-2024-003', title: 'Safety Equipment Restock', subtitle: 'Requester: Mike J. · Safety',
        detail: 'SAR 8,200', status: 'pending', statusColor: C.warning, icon: 'document-text',
        priority: 'medium', date: '2024-03-16',
        lineItems: [
          { name: 'Hard Hats', qty: 50, price: 'SAR 80', total: 'SAR 4,000' },
          { name: 'Safety Vests', qty: 50, price: 'SAR 60', total: 'SAR 3,000' },
          { name: 'Safety Goggles', qty: 30, price: 'SAR 40', total: 'SAR 1,200' },
        ],
        workflow: [
          { step: 'Submitted', user: 'Mike J.', date: 'Mar 16, 09:00', status: 'completed' },
          { step: 'Department Review', user: '', date: '', status: 'current' },
          { step: 'Budget Approval', user: '', date: '', status: 'pending' },
        ],
      },
    ],
  },
  'view-orders': {
    type: 'list',
    title: 'Orders',
    items: [
      { id: 'PO-2024-001', title: 'PO-2024-001 · Acme Corp', subtitle: 'IT Equipment · 15 items', detail: 'SAR 45,000', status: 'in transit', statusColor: C.primary, icon: 'cube', date: 'Mar 10', eta: 'Mar 20', tracking: 'TRK-8827341' },
      { id: 'PO-2024-002', title: 'PO-2024-002 · TechParts', subtitle: 'Electronics · PCB Batch', detail: 'SAR 7,200', status: 'delivered', statusColor: C.success, icon: 'cube', date: 'Mar 5', deliveredDate: 'Mar 12' },
      { id: 'PO-2024-003', title: 'PO-2024-003 · Global Supply', subtitle: 'Raw Materials · Steel', detail: 'SAR 24,100', status: 'processing', statusColor: C.warning, icon: 'cube', date: 'Mar 15' },
      { id: 'PO-2024-004', title: 'PO-2024-004 · SafetyFirst', subtitle: 'Safety Gear · Bulk', detail: 'SAR 8,200', status: 'approved', statusColor: C.secondary, icon: 'cube', date: 'Mar 16' },
    ],
  },
  'track-shipment': {
    type: 'list',
    title: 'Active Shipments',
    items: [
      {
        id: 'SHP-101', title: 'SHP-101 · Shanghai → Jeddah', subtitle: 'Carrier: Maersk · Container', detail: 'ETA: 3 days',
        status: 'in transit', statusColor: C.primary, icon: 'boat',
        tracking: [
          { step: 'Origin Port', location: 'Shanghai, CN', date: 'Mar 8', status: 'completed' },
          { step: 'Customs Cleared', location: 'Shanghai, CN', date: 'Mar 9', status: 'completed' },
          { step: 'In Transit', location: 'Indian Ocean', date: 'Mar 15', status: 'current' },
          { step: 'Destination Port', location: 'Jeddah, SA', date: 'Mar 18 (est)', status: 'pending' },
          { step: 'Delivered', location: 'Warehouse', date: 'Mar 20 (est)', status: 'pending' },
        ],
      },
      {
        id: 'SHP-102', title: 'SHP-102 · Local Delivery', subtitle: 'Driver: Tom W. · Van #B-105', detail: 'ETA: Today',
        status: 'arriving', statusColor: C.success, icon: 'car',
        tracking: [
          { step: 'Picked Up', location: 'Main Warehouse', date: 'Today, 08:00', status: 'completed' },
          { step: 'In Transit', location: 'Highway 40', date: 'Today, 09:15', status: 'completed' },
          { step: 'Arriving', location: 'Store #123', date: 'Today, 10:30', status: 'current' },
        ],
      },
    ],
  },
};

// ─── Maintenance ───
export const MAINTENANCE_DATA = {
  'new-request': {
    type: 'form',
    title: 'New Maintenance Request',
    fields: [
      { key: 'title', label: 'Title', placeholder: 'Brief description of issue...', type: 'text' },
      { key: 'facility', label: 'Facility', placeholder: 'Store #123 / Warehouse / HQ', type: 'text' },
      { key: 'location', label: 'Location Detail', placeholder: 'Building / Floor / Room', type: 'text' },
      { key: 'priority', label: 'Priority', placeholder: 'Low / Medium / High / Critical', type: 'text' },
      { key: 'type', label: 'Request Type', placeholder: 'Repair / Preventive / Installation / Inspection', type: 'text' },
      { key: 'asset', label: 'Asset (if applicable)', placeholder: 'Asset name or ID...', type: 'text' },
      { key: 'description', label: 'Description', placeholder: 'Detailed description of the issue...', type: 'textarea' },
    ],
  },
  'view-tickets': {
    type: 'list',
    title: 'Maintenance Tickets',
    items: [
      {
        id: 'MT-001', title: 'AC Unit Malfunction', subtitle: 'Store #123 · Dining Area',
        detail: '2h ago', status: 'in progress', statusColor: C.warning, icon: 'flame',
        priority: 'high', assignedTo: 'Mike Tech', progress: 65,
        asset: { id: 'AC-123', name: 'Carrier AC Unit', serial: 'CAR123456789' },
        sla: { response: '30 min', resolution: '4 hours', status: 'on track' },
        timeline: [
          { step: 'Submitted', user: 'John Doe', date: 'Today, 09:30', detail: 'Ticket created', status: 'completed' },
          { step: 'Assigned', user: 'System', date: 'Today, 09:35', detail: 'Assigned to Mike Tech', status: 'completed' },
          { step: 'Diagnosed', user: 'Mike Tech', date: 'Today, 10:00', detail: 'Compressor failure identified', status: 'completed' },
          { step: 'Parts Ordered', user: 'Mike Tech', date: 'Today, 10:15', detail: 'Replacement compressor ordered', status: 'completed' },
          { step: 'Repair', user: 'Mike Tech', date: '', detail: 'Awaiting parts delivery', status: 'current' },
          { step: 'Testing', user: '', date: '', detail: 'System test after repair', status: 'pending' },
          { step: 'Resolved', user: '', date: '', detail: '', status: 'pending' },
        ],
      },
      {
        id: 'MT-002', title: 'Elevator B - Strange Noise', subtitle: 'HQ · Tower A',
        detail: '5h ago', status: 'assigned', statusColor: C.primary, icon: 'swap-vertical',
        priority: 'high', assignedTo: 'Sarah Williams', progress: 20,
        asset: { id: 'ELV-B', name: 'Elevator B - Tower A', serial: 'OTS-2021-B-445' },
        sla: { response: '1 hour', resolution: '8 hours', status: 'on track' },
        timeline: [
          { step: 'Submitted', user: 'Reception', date: 'Today, 07:00', detail: 'Grinding noise reported', status: 'completed' },
          { step: 'Assigned', user: 'System', date: 'Today, 07:15', detail: 'Assigned to Sarah W.', status: 'completed' },
          { step: 'Diagnosis', user: 'Sarah W.', date: '', detail: 'Inspection pending', status: 'current' },
          { step: 'Repair', user: '', date: '', detail: '', status: 'pending' },
          { step: 'Testing', user: '', date: '', detail: '', status: 'pending' },
          { step: 'Resolved', user: '', date: '', detail: '', status: 'pending' },
        ],
      },
      {
        id: 'MT-003', title: 'Parking Lot Lights Out', subtitle: 'Store #124 · Lot B',
        detail: '1d ago', status: 'resolved', statusColor: C.success, icon: 'bulb',
        priority: 'medium', assignedTo: 'Ali R.', progress: 100,
        timeline: [
          { step: 'Submitted', user: 'Security', date: 'Yesterday, 18:00', detail: '3 lights not working', status: 'completed' },
          { step: 'Assigned', user: 'System', date: 'Yesterday, 18:10', detail: 'Assigned to Ali R.', status: 'completed' },
          { step: 'Diagnosed', user: 'Ali R.', date: 'Yesterday, 19:00', detail: 'Ballast failure', status: 'completed' },
          { step: 'Repaired', user: 'Ali R.', date: 'Today, 08:30', detail: '3 ballasts replaced', status: 'completed' },
          { step: 'Resolved', user: 'Ali R.', date: 'Today, 09:00', detail: 'All lights operational', status: 'completed' },
        ],
      },
    ],
  },
  'schedule': {
    type: 'list',
    title: 'Maintenance Schedule',
    items: [
      { id: 'SCH-1', title: 'Generator Inspection', subtitle: 'Store #123 · Basement', detail: 'Today, 2:00 PM', status: 'upcoming', statusColor: C.warning, icon: 'flash', assignedTo: 'Mike Tech', type: 'Preventive' },
      { id: 'SCH-2', title: 'Fire Suppression Test', subtitle: 'All Stores', detail: 'Tomorrow, 9:00 AM', status: 'scheduled', statusColor: C.primary, icon: 'flame', assignedTo: 'Safety Team', type: 'Inspection' },
      { id: 'SCH-3', title: 'HVAC Filter Replace', subtitle: 'HQ · Floors 1-5', detail: 'Mar 5, 10:00 AM', status: 'scheduled', statusColor: C.primary, icon: 'thermometer', assignedTo: 'HVAC Team', type: 'Preventive' },
      { id: 'SCH-4', title: 'Elevator Annual Cert', subtitle: 'HQ · All Elevators', detail: 'Mar 10', status: 'planned', statusColor: C.textDim, icon: 'swap-vertical', assignedTo: 'Otis Service', type: 'Inspection' },
    ],
  },
  'reports': {
    type: 'list',
    title: 'Maintenance Reports',
    items: [
      { id: 'RPT-1', title: 'Monthly Summary - Feb', subtitle: '47 tickets resolved · 94% SLA', detail: 'SAR 12,400', status: 'complete', statusColor: C.success, icon: 'bar-chart', metrics: { resolved: 47, avgTime: '3.2h', sla: '94%', cost: 'SAR 12,400' } },
      { id: 'RPT-2', title: 'Cost Analysis Q1', subtitle: 'Budget vs Actual spend', detail: 'SAR 45,200', status: 'complete', statusColor: C.success, icon: 'pie-chart', metrics: { budget: 'SAR 50,000', actual: 'SAR 45,200', variance: '-9.6%', savings: 'SAR 4,800' } },
      { id: 'RPT-3', title: 'Equipment Health', subtitle: 'Predictive maintenance alerts', detail: '12 alerts', status: 'attention', statusColor: C.warning, icon: 'pulse', metrics: { healthy: 142, warning: 12, critical: 3, totalAssets: 157 } },
    ],
  },
};

// ─── Logistics ───
export const LOGISTICS_DATA = {
  'new-delivery': {
    type: 'form',
    title: 'New Delivery Request',
    fields: [
      { key: 'type', label: 'Delivery Type', placeholder: 'Warehouse-to-Store / Equipment Move / Central Kitchen', type: 'text' },
      { key: 'origin', label: 'Origin', placeholder: 'Pickup location...', type: 'text' },
      { key: 'destination', label: 'Destination', placeholder: 'Drop-off location...', type: 'text' },
      { key: 'items', label: 'Items', placeholder: 'Item descriptions and quantities...', type: 'textarea' },
      { key: 'weight', label: 'Total Weight (kg)', placeholder: '0', type: 'number' },
      { key: 'priority', label: 'Priority', placeholder: 'Standard / Express / Emergency', type: 'text' },
      { key: 'required_date', label: 'Required Date', placeholder: 'YYYY-MM-DD', type: 'text' },
      { key: 'special', label: 'Special Requirements', placeholder: 'Temperature control, fragile, etc.', type: 'textarea' },
    ],
  },
  'track-fleet': {
    type: 'list',
    title: 'Fleet Status',
    items: [
      { id: 'VH-001', title: 'Truck #A-201 · Isuzu NPR', subtitle: 'Driver: Mohammed A. · Route 5', detail: 'Fuel: 72%', status: 'in transit', statusColor: C.success, icon: 'car', licensePlate: 'ABC-1234', odometer: '45,230 km', capacity: '3,500 kg', location: 'Highway 40, Jeddah' },
      { id: 'VH-002', title: 'Van #B-105 · Toyota HiAce', subtitle: 'Driver: Tom W. · Downtown', detail: 'Fuel: 45%', status: 'in transit', statusColor: C.success, icon: 'car', licensePlate: 'DEF-5678', odometer: '32,100 km', capacity: '1,200 kg', location: 'King Fahd Rd' },
      { id: 'VH-003', title: 'Truck #A-203 · Isuzu NPR', subtitle: 'No driver assigned', detail: 'Fuel: 90%', status: 'available', statusColor: C.primary, icon: 'car', licensePlate: 'GHI-9012', odometer: '18,500 km', capacity: '3,500 kg', location: 'Main Depot' },
      { id: 'VH-004', title: 'Refrigerated #C-01', subtitle: 'Driver: Lisa C. · Returning', detail: 'Temp: -18°C', status: 'returning', statusColor: C.warning, icon: 'snow', licensePlate: 'JKL-3456', odometer: '62,800 km', capacity: '2,000 kg', location: 'Exit 15, Inbound' },
    ],
  },
  'routes': {
    type: 'list',
    title: 'Active Routes',
    items: [
      { id: 'RT-001', title: 'Route 1 · Downtown Loop', subtitle: '8 stops · 45 km · 3h estimated', detail: '5/8 done', status: 'active', statusColor: C.success, icon: 'navigate', vehicle: 'Van #B-105', driver: 'Tom W.', efficiency: '92%',
        waypoints: ['Main Warehouse', 'Store #101', 'Store #102', 'Store #103', 'Store #104', 'Cafe Downtown', 'Store #105', 'Return'] },
      { id: 'RT-002', title: 'Route 2 · Industrial Zone', subtitle: '5 stops · 62 km · 4h estimated', detail: '2/5 done', status: 'active', statusColor: C.success, icon: 'navigate', vehicle: 'Truck #A-201', driver: 'Mohammed A.', efficiency: '88%' },
      { id: 'RT-003', title: 'Route 3 · Suburban', subtitle: '12 stops · 38 km · 5h estimated', detail: 'Starts 1:00 PM', status: 'planned', statusColor: C.primary, icon: 'navigate', vehicle: 'Truck #A-203', driver: 'Unassigned', efficiency: '-' },
    ],
  },
  'drivers': {
    type: 'list',
    title: 'Drivers',
    items: [
      { id: 'DR-001', title: 'Mohammed Al-Salem', subtitle: 'Truck #A-201 · Route 2', detail: '98% on-time', status: 'on duty', statusColor: C.success, icon: 'person', license: 'Heavy Vehicle', phone: '+966 55 123 4567', deliveries: 1247, rating: 4.9, safetyScore: 98 },
      { id: 'DR-002', title: 'Tom Wilson', subtitle: 'Van #B-105 · Route 1', detail: '95% on-time', status: 'on duty', statusColor: C.success, icon: 'person', license: 'Light Vehicle', phone: '+966 55 234 5678', deliveries: 892, rating: 4.7, safetyScore: 95 },
      { id: 'DR-003', title: 'Lisa Chen', subtitle: 'Refrigerated #C-01 · Returning', detail: '97% on-time', status: 'on duty', statusColor: C.success, icon: 'person', license: 'Heavy + Hazmat', phone: '+966 55 345 6789', deliveries: 1050, rating: 4.8, safetyScore: 99 },
      { id: 'DR-004', title: 'James Park', subtitle: 'No vehicle assigned', detail: '92% on-time', status: 'available', statusColor: C.primary, icon: 'person', license: 'Light Vehicle', phone: '+966 55 456 7890', deliveries: 634, rating: 4.5, safetyScore: 93 },
    ],
  },
};

// ─── Assets ───
export const ASSETS_DATA = {
  'add-asset': {
    type: 'form',
    title: 'Add New Asset',
    fields: [
      { key: 'name', label: 'Asset Name', placeholder: 'e.g. Commercial Refrigerator XL-5000', type: 'text' },
      { key: 'category', label: 'Category', placeholder: 'Equipment / Vehicle / Technology / Furniture', type: 'text' },
      { key: 'serial', label: 'Serial Number', placeholder: 'e.g. CT2023081500123', type: 'text' },
      { key: 'manufacturer', label: 'Manufacturer', placeholder: 'e.g. Dell, Carrier, Toyota', type: 'text' },
      { key: 'model', label: 'Model', placeholder: 'Model name or number', type: 'text' },
      { key: 'location', label: 'Location', placeholder: 'Store #123 / Warehouse / HQ Floor 2', type: 'text' },
      { key: 'value', label: 'Purchase Cost (SAR)', placeholder: '0.00', type: 'number', prefix: 'SAR' },
      { key: 'assigned_to', label: 'Assigned To', placeholder: 'Employee name or department', type: 'text' },
    ],
  },
  'scan-asset': { type: 'scanner', title: 'Scan Asset QR', scanType: 'qr' },
  'view-assets': {
    type: 'list',
    title: 'Assets',
    items: [
      {
        id: 'AST-001', title: 'Commercial Refrigerator XL-5000', subtitle: 'Store #123 · Kitchen',
        detail: 'SAR 15,000', status: 'active', statusColor: C.success, icon: 'snow',
        serial: 'CT2023081500123', manufacturer: 'CoolTech', model: 'XL-5000',
        category: 'Kitchen Equipment', assignedTo: 'Store #123 Kitchen',
        purchaseDate: '2023-08-15', warranty: 'Until 2026-08-15',
        condition: 0.85, currentValue: 'SAR 12,000',
        maintenanceHistory: [
          { date: '2024-02-20', type: 'Preventive', cost: 'SAR 450', desc: 'Regular maintenance check' },
          { date: '2024-01-10', type: 'Repair', cost: 'SAR 1,200', desc: 'Compressor seal replaced' },
        ],
        hasQR: true,
      },
      {
        id: 'AST-002', title: 'Dell XPS 15 Laptop', subtitle: 'HQ · IT Department',
        detail: 'SAR 9,500', status: 'active', statusColor: C.success, icon: 'laptop',
        serial: 'DL2023111500123', manufacturer: 'Dell', model: 'XPS 15 9530',
        category: 'Technology', assignedTo: 'Ahmed Hassan · IT Dept',
        purchaseDate: '2023-11-15', warranty: 'Until 2025-11-15',
        condition: 0.92, currentValue: 'SAR 7,600',
        maintenanceHistory: [],
        hasQR: true,
      },
      {
        id: 'AST-003', title: 'Toyota Forklift 8FGU25', subtitle: 'Main Warehouse · Zone A',
        detail: 'SAR 105,000', status: 'active', statusColor: C.success, icon: 'car',
        serial: 'TY2022031500789', manufacturer: 'Toyota', model: '8FGU25',
        category: 'Vehicle', assignedTo: 'Warehouse Operations',
        purchaseDate: '2022-03-15', warranty: 'Until 2025-03-15',
        condition: 0.78, currentValue: 'SAR 82,000',
        maintenanceHistory: [
          { date: '2024-03-01', type: 'Preventive', cost: 'SAR 2,800', desc: 'Annual service + oil change' },
          { date: '2024-01-15', type: 'Repair', cost: 'SAR 800', desc: 'Hydraulic hose replaced' },
          { date: '2023-09-20', type: 'Preventive', cost: 'SAR 2,500', desc: 'Semi-annual service' },
        ],
        hasQR: true,
      },
      {
        id: 'AST-004', title: 'Carrier HVAC Unit 50XC', subtitle: 'HQ · Floor 3',
        detail: 'SAR 45,000', status: 'maintenance', statusColor: C.warning, icon: 'thermometer',
        serial: 'CAR2021061200456', manufacturer: 'Carrier', model: '50XC',
        category: 'HVAC', assignedTo: 'HQ Building Services',
        purchaseDate: '2021-06-12', warranty: 'Expired',
        condition: 0.55, currentValue: 'SAR 28,000',
        maintenanceHistory: [
          { date: '2024-03-10', type: 'Repair', cost: 'SAR 3,500', desc: 'Compressor replacement - in progress' },
          { date: '2024-01-20', type: 'Preventive', cost: 'SAR 600', desc: 'Filter and belt replacement' },
        ],
        hasQR: true,
      },
    ],
  },
  'asset-maintenance': {
    type: 'list',
    title: 'Asset Maintenance',
    items: [
      { id: 'AM-1', title: 'HVAC Unit 50XC - Compressor', subtitle: 'HQ Floor 3 · Carrier', detail: 'Due: Today', status: 'in progress', statusColor: C.warning, icon: 'construct', cost: 'SAR 3,500', assignedTo: 'HVAC Team', type: 'Repair' },
      { id: 'AM-2', title: 'Forklift 8FGU25 - Annual Service', subtitle: 'Warehouse · Toyota', detail: 'Due: Mar 15', status: 'scheduled', statusColor: C.primary, icon: 'construct', cost: 'SAR 2,800', assignedTo: 'Toyota Service', type: 'Preventive' },
      { id: 'AM-3', title: 'Generator - Fuel Filter', subtitle: 'Store #123 · Cat', detail: 'Due: Mar 20', status: 'scheduled', statusColor: C.primary, icon: 'construct', cost: 'SAR 400', assignedTo: 'Mike Tech', type: 'Preventive' },
    ],
  },
};

// ─── Inventory ───
export const INVENTORY_DATA = {
  'add-item': {
    type: 'form',
    title: 'Add Inventory Item',
    fields: [
      { key: 'name', label: 'Item Name', placeholder: 'Product name...', type: 'text' },
      { key: 'sku', label: 'SKU', placeholder: 'e.g. ELEC-001', type: 'text' },
      { key: 'category', label: 'Category', placeholder: 'Electronics / Raw Materials / Supplies', type: 'text' },
      { key: 'quantity', label: 'Quantity', placeholder: '0', type: 'number' },
      { key: 'unit_cost', label: 'Unit Cost (SAR)', placeholder: '0.00', type: 'number', prefix: 'SAR' },
      { key: 'location', label: 'Location', placeholder: 'Zone A-12 / Aisle 3 / Shelf B', type: 'text' },
      { key: 'reorder_level', label: 'Reorder Level', placeholder: 'Min stock before reorder', type: 'number' },
      { key: 'supplier', label: 'Supplier', placeholder: 'Primary supplier name', type: 'text' },
    ],
  },
  'scan-barcode': { type: 'scanner', title: 'Scan Barcode', scanType: 'barcode' },
  'stock-check': {
    type: 'list',
    title: 'Stock Check',
    items: [
      { id: 'STK-1', title: 'Laptop Dell XPS 15', subtitle: 'SKU: ELEC-001 · Zone A-12', detail: '125 units', status: 'in stock', statusColor: C.success, icon: 'cube', value: 'SAR 125,000', reorderLevel: 20, lastCount: 'Mar 10' },
      { id: 'STK-2', title: 'Safety Goggles', subtitle: 'SKU: SAFE-003 · Zone C-01', detail: '8 units', status: 'low stock', statusColor: C.danger, icon: 'cube', value: 'SAR 320', reorderLevel: 30, lastCount: 'Mar 12' },
      { id: 'STK-3', title: 'Printer Paper A4', subtitle: 'SKU: OFF-012 · Zone B-05', detail: '340 reams', status: 'in stock', statusColor: C.success, icon: 'cube', value: 'SAR 5,100', reorderLevel: 100, lastCount: 'Mar 11' },
      { id: 'STK-4', title: 'M8 Bolt Pack (100)', subtitle: 'SKU: HW-030 · Zone D-08', detail: '12 packs', status: 'reorder', statusColor: C.warning, icon: 'cube', value: 'SAR 360', reorderLevel: 25, lastCount: 'Mar 9' },
      { id: 'STK-5', title: 'Cleaning Solution 5L', subtitle: 'SKU: CLN-005 · Zone C-03', detail: '45 units', status: 'in stock', statusColor: C.success, icon: 'cube', value: 'SAR 1,350', reorderLevel: 15, lastCount: 'Mar 13' },
    ],
  },
  'inv-reports': {
    type: 'list',
    title: 'Inventory Reports',
    items: [
      { id: 'IR-1', title: 'Stock Valuation', subtitle: 'Total inventory value across all zones', detail: 'SAR 1.2M', status: 'current', statusColor: C.success, icon: 'bar-chart', metrics: { totalItems: 2847, categories: 12, zones: 8, accuracy: '98.5%' } },
      { id: 'IR-2', title: 'Turnover Analysis', subtitle: 'Last 30 days item movement', detail: '4.2x turn', status: 'current', statusColor: C.success, icon: 'trending-up', metrics: { fastMoving: 145, slowMoving: 67, deadStock: 23, avgDays: 8.6 } },
      { id: 'IR-3', title: 'Dead Stock Report', subtitle: '23 items with no movement 90d+', detail: 'SAR 8,400', status: 'attention', statusColor: C.warning, icon: 'alert-circle', metrics: { items: 23, value: 'SAR 8,400', oldestItem: '180 days', recommendAction: 'Liquidate or donate' } },
    ],
  },
};

// ─── Procurement ───
export const PROCUREMENT_DATA = {
  'create-rfq': {
    type: 'form',
    title: 'Create RFQ',
    fields: [
      { key: 'title', label: 'RFQ Title', placeholder: 'What are you sourcing?', type: 'text' },
      { key: 'category', label: 'Category', placeholder: 'Raw Materials / Equipment / Services', type: 'text' },
      { key: 'description', label: 'Specifications', placeholder: 'Detailed requirements and specs...', type: 'textarea' },
      { key: 'quantity', label: 'Quantity', placeholder: '0', type: 'number' },
      { key: 'deadline', label: 'Response Deadline', placeholder: 'YYYY-MM-DD', type: 'text' },
      { key: 'budget', label: 'Budget Range (SAR)', placeholder: 'e.g. 5,000 - 10,000', type: 'text' },
      { key: 'vendors', label: 'Invite Vendors', placeholder: 'Vendor names (comma separated)', type: 'text' },
    ],
  },
  'vendors': {
    type: 'list',
    title: 'Vendors',
    items: [
      { id: 'V-001', title: 'Acme Corporation', subtitle: 'Raw Materials · Since 2019', detail: '4.8 ★', status: 'active', statusColor: C.success, icon: 'business', totalSpend: 'SAR 450,000', activePOs: 3, onTimeDelivery: '96%', qualityScore: '4.8/5', contracts: 2, phone: '+966 12 345 6789', email: 'sales@acme.sa' },
      { id: 'V-002', title: 'TechParts Ltd', subtitle: 'Electronics · Since 2021', detail: '4.5 ★', status: 'active', statusColor: C.success, icon: 'business', totalSpend: 'SAR 280,000', activePOs: 2, onTimeDelivery: '93%', qualityScore: '4.5/5', contracts: 1, phone: '+966 12 456 7890', email: 'info@techparts.sa' },
      { id: 'V-003', title: 'Global Supply Co', subtitle: 'General Supplies · Since 2018', detail: '4.2 ★', status: 'active', statusColor: C.success, icon: 'business', totalSpend: 'SAR 620,000', activePOs: 5, onTimeDelivery: '91%', qualityScore: '4.2/5', contracts: 3, phone: '+966 12 567 8901', email: 'orders@globalsupply.sa' },
      { id: 'V-004', title: 'FastShip Inc', subtitle: 'Logistics Services · Since 2022', detail: '3.9 ★', status: 'under review', statusColor: C.warning, icon: 'business', totalSpend: 'SAR 95,000', activePOs: 1, onTimeDelivery: '85%', qualityScore: '3.9/5', contracts: 1, phone: '+966 12 678 9012', email: 'ops@fastship.sa' },
    ],
  },
  'quotes': {
    type: 'list',
    title: 'Quotes',
    items: [
      { id: 'QT-2024-078', title: 'QT-078 · Raw Steel Batch', subtitle: 'From: Acme Corp · RFQ-2024-045', detail: 'SAR 18,500', status: 'awaiting review', statusColor: C.warning, icon: 'receipt', validUntil: 'Mar 25', items: 3, deliveryTerms: 'FOB Jeddah, 14 days' },
      { id: 'QT-2024-079', title: 'QT-079 · PCB Components', subtitle: 'From: TechParts · RFQ-2024-046', detail: 'SAR 7,200', status: 'accepted', statusColor: C.success, icon: 'receipt', validUntil: 'Mar 30', items: 5, deliveryTerms: 'CIF Riyadh, 21 days' },
      { id: 'QT-2024-080', title: 'QT-080 · Office Furniture', subtitle: 'From: FurnishPro · RFQ-2024-043', detail: 'SAR 22,000', status: 'expired', statusColor: C.textDim, icon: 'receipt', validUntil: 'Mar 1', items: 8, deliveryTerms: 'Delivered, 30 days' },
    ],
  },
  'proc-orders': {
    type: 'list',
    title: 'Procurement Orders',
    items: [
      { id: 'PRO-2024-041', title: 'PRO-041 · Raw Steel', subtitle: 'Acme Corp · Ordered Mar 10', detail: 'SAR 18,500', status: 'in transit', statusColor: C.primary, icon: 'cart', eta: 'Mar 24', tracking: 'SHP-2024-889' },
      { id: 'PRO-2024-042', title: 'PRO-042 · PCB Components', subtitle: 'TechParts · Ordered Mar 8', detail: 'SAR 7,200', status: 'delivered', statusColor: C.success, icon: 'cart', deliveredDate: 'Mar 15', receivedBy: 'Warehouse Team' },
      { id: 'PRO-2024-043', title: 'PRO-043 · Express Delivery', subtitle: 'FastShip · Ordered Mar 12', detail: 'SAR 2,100', status: 'processing', statusColor: C.warning, icon: 'cart', eta: 'Mar 18' },
    ],
  },
};

// ─── Pulse (Lyncs Neo — full-screen tabs, see pulseNeoData.js) ───
export const PULSE_DATA = {
  'pulse-tab-overview': { type: 'pulse-tab', pulseTab: 'overview', title: 'Pulse · Overview' },
  'pulse-tab-analytics': { type: 'pulse-tab', pulseTab: 'analytics', title: 'Pulse · Analytics' },
  'pulse-tab-map': { type: 'pulse-tab', pulseTab: 'map', title: 'Pulse · Map' },
  'pulse-tab-comparison': { type: 'pulse-tab', pulseTab: 'comparison', title: 'Pulse · Comparison' },
  'pulse-tab-rankings': { type: 'pulse-tab', pulseTab: 'rankings', title: 'Pulse · Rankings' },
  'pulse-tab-performance': { type: 'pulse-tab', pulseTab: 'performance', title: 'Pulse · Performance' },
};

export function getActionDef(actionId) {
  return SUPPLY_CHAIN_DATA[actionId]
    || MAINTENANCE_DATA[actionId]
    || LOGISTICS_DATA[actionId]
    || ASSETS_DATA[actionId]
    || INVENTORY_DATA[actionId]
    || PROCUREMENT_DATA[actionId]
    || PULSE_DATA[actionId]
    || null;
}
